import React from 'react';
import {aceCustId} from '../../../context/context';
import OpenInNewLink from '../../../libs/react-components-admin/link/open-in-new-link';
import PreviousNext from './previous-next';

const Step1 = ({onDone}) => {

  return <>
    <ul style={{lineHeight: '1.8em'}}>
      <li>
        Open your <OpenInNewLink href={`https://${aceCustId}/admin/themes/current/editor`}>theme
        editor</OpenInNewLink> and navigate to the page template you wish to edit.
      </li>
      <li>
        Add a block or a section, scroll down and choose &apos;Custom Form&apos;:<br/>
        <img src="/images/osv2-apps-custom-form.png" alt="Custom forms app block"/>
      </li>
      <li>
        Click on &apos;Save&apos;.
      </li>
    </ul>
    <PreviousNext hidePrevious={true} onNextClicked={() => onDone()}/>
  </>;
};
export default Step1;
